const urlCheckerRegex = /(https?:\/\/)?(www\.)?[a-zA-Z0-9\-_.]+(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?(\/[a-zA-Z0-9\-._~:\/?#\[\]@!$&'()*+,;=%]*)?(\?[a-zA-Z0-9\-._~:\/?#\[\]@!$&'()*+,;=%]*)?/g;

export { urlCheckerRegex }